/**
 * Initializes the sidebar navigation functionality.
 * Handles submenu toggling and menu state management.
 *
 * Key features:
 * - Uses event delegation for efficient click handling
 * - Manages submenu open/close states
 * - Handles chevron rotation animations
 * - Maintains menu hierarchy (closes sibling menus)
 */
export function initSidebarNav() {
  const navTree = document.querySelector('.nav-tree');
  const sidebar = document.querySelector('.sidebar');

  if (!navTree || !sidebar) {
    // console.warn("Navigation tree element '.nav-tree' not found.")
    return;
  }

  navTree.addEventListener('click', (event) => {
    const sidebar = document.querySelector('.sidebar');

    // Complete early exit for sidebar-mini - don't process any nav events
    if (sidebar?.classList.contains('sidebar-mini')) {
      return; // Let the flyout handler deal with it
    }

    const link = event.target.closest('.nav-link');
    if (!link) return;

    const navItem = link.closest('.nav-item');
    // Only process clicks on menu items with submenus
    if (!navItem?.classList.contains('has-submenu')) {
      // For child items without submenus, don't prevent default or process further
      return;
    }

    // Prevent default navigation for submenu toggles
    event.preventDefault();
    // Stop propagation to prevent parent menu handlers from firing
    event.stopPropagation();

    const isCurrentlyOpen = navItem.classList.contains('open');
    const isTopLevelItem = !navItem.closest('.submenu');

    // If opening a menu, close its siblings first
    if (!isCurrentlyOpen) {
      // Find and close other open menus at the same level
      const parentList = navItem.closest(isTopLevelItem ? '.nav-tree' : '.submenu');
      const siblingSubmenus = parentList.querySelectorAll(':scope > .nav-item.has-submenu.open');

      siblingSubmenus.forEach((sibling) => {
        if (sibling !== navItem) {
          sibling.classList.remove('open');
          const chevron = sibling.querySelector('.ri-arrow-right-s-line');
          if (chevron) chevron.style.transform = '';
        }
      });
    }

    // Toggle the clicked menu's state
    navItem.classList.toggle('open');
  });
}
